import "./styles.scss";

import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { connect, ConnectedProps } from "react-redux";
import { FormattedMessage } from "react-intl";
import {Button, Modal } from "@material-ui/core";

import UserAPI from "../../../../authentication/apis/user.api";
import { ToastType } from "../../../../common/submodules/toast/enums/toast-type.enum";
import { config } from "../../../../../config";
import { ReducerAction } from "../../../../reducer/enums/reducer-action.enum";
import { HeaderErrors } from "../../../enums/header.enum";
import { IReducerState } from "../../../../reducer/interfaces/reducer.interface";

type PropsFromRedux = ConnectedProps<typeof connector>;
interface IProps extends PropsFromRedux, RouteComponentProps {
  isDeleteProfilePopupVisible: boolean;
  closeDeleteProfilePopUp(): void;
  user:any;
}

class DeleteProfilePopup extends React.Component<IProps> {
  private deleteUserProfile = (): void => {
    UserAPI.deleteUser()
      .then(() => {
        this.props.displayToast(
          <FormattedMessage id="deleteUser.userDeleted" />
        );

        this.onDisconnectClick();
      })
      .catch((error) => {
        if (
          error.response.data.description === HeaderErrors.USER_NOT_DEACTIVATED
        ) {
          this.props.displayToast(
            <FormattedMessage id="deleteUser.userNotDeactivated" />,
            ToastType.WARNING
          );

          this.onDisconnectClick();
        } else {
          this.props.displayToast(
            <FormattedMessage id="error.errorOccurredFull" />,
            ToastType.ERROR
          );
        }
      });
  };

  private onDisconnectClick = (): void => {
    this.props.disconnectUser();
    window.location.replace(config.logoutUrl);
  };

  render() {
    return (
      <Modal open={this.props.isDeleteProfilePopupVisible}>
        <div id="new-customer" className="success App-content">
          
            <div className="title">
              <FormattedMessage id="popUp.deleteUser.title" />
            </div>
            <div className="message">
              <FormattedMessage id="popUp.deleteUser.message" />
            </div>
            <div style={{ marginLeft: "10px" }}><span className="name">{this.props.user.givenName}</span> <span className="name">{this.props.user.familyName}</span><br />
          <span className="email">{this.props.user.email}</span> &nbsp;&nbsp;&nbsp;&nbsp;
          {this.props.user?.main &&<svg style={{ marginTop: "-40px" }} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.22965 0C7.61965 0 8.01965 0.03 8.40965 0.1C8.67965 0.14 8.85965 0.4 8.81965 0.67C8.77965 0.94 8.51965 1.12 8.25965 1.07C7.91965 1.02 7.57965 0.99 7.23965 0.99C4.90965 0.99 2.77965 2.27 1.68965 4.33C1.59965 4.49 1.43965 4.59 1.25965 4.59C1.17965 4.59 1.09965 4.57 1.02965 4.53C0.789652 4.4 0.699652 4.11 0.819652 3.87C2.06965 1.48 4.52965 0 7.22965 0ZM0.569652 6.01H0.589652C0.859652 6.04 1.05965 6.28 1.02965 6.55L1.00965 6.71C0.899652 7.95 1.15965 9.18 1.74965 10.26C1.87965 10.5 1.78965 10.8 1.54965 10.93C1.45965 10.98 1.36965 11 1.26965 10.99C1.10965 10.98 0.959652 10.88 0.879652 10.74C0.199652 9.47 -0.100348 8.05 0.0296518 6.62L0.0496518 6.45C0.0796518 6.18 0.309652 6.01 0.569652 6.01ZM10.4897 0.77L10.7297 0.9C13.0497 2.18 14.4797 4.59 14.4797 7.25C14.4797 8.87 13.9597 10.4 12.9697 11.68C12.8797 11.8 12.7297 11.87 12.5797 11.87C12.4697 11.87 12.3697 11.83 12.2797 11.77C12.0597 11.6 12.0197 11.3 12.1897 11.08C13.0397 9.97 13.4997 8.65 13.4997 7.25C13.4997 4.87 12.1797 2.72 10.0497 1.65C9.80965 1.53 9.70965 1.23 9.82965 0.99C9.94965 0.75 10.2497 0.65 10.4897 0.77ZM2.61965 11.5L2.81965 11.71C3.98965 12.86 5.57965 13.52 7.22965 13.52C8.54965 13.52 9.80965 13.11 10.8797 12.35C11.0997 12.19 11.4097 12.24 11.5697 12.46C11.7297 12.68 11.6797 12.99 11.4597 13.15C10.2197 14.04 8.75965 14.51 7.22965 14.51C5.20965 14.51 3.26965 13.66 1.89965 12.17C1.71965 11.97 1.72965 11.66 1.92965 11.48C2.12965 11.29 2.43965 11.31 2.62965 11.51L2.61965 11.5ZM4.77965 3.82C4.22965 4.51 4.10965 5.4 4.21965 6.27C4.07965 6.42 4.00965 6.6 3.98965 6.78C3.92965 7.27 4.22965 7.74 4.67965 8.18C4.71965 8.96 4.95965 9.56 5.26965 10C5.18965 10.33 4.83965 10.66 4.31965 10.95C4.11965 11.06 3.90965 11.15 3.71965 11.22L3.57965 11.27L3.49965 11.3C3.28965 11.41 3.17965 11.66 3.24965 11.89C3.31965 12.1 3.50965 12.24 3.72965 12.24C3.77965 12.24 3.82965 12.24 3.87965 12.22C4.00965 12.18 4.20965 12.11 4.44965 12C5.54965 11.5 6.28965 10.8 6.28965 9.85C6.28965 9.75 6.25965 9.66 6.20965 9.58L6.09965 9.45L6.03965 9.36L5.95965 9.22L5.88965 9.07L5.82965 8.91C5.72965 8.63 5.67965 8.32 5.67965 7.96C5.67965 7.81 5.61965 7.68 5.50965 7.58C5.27965 7.39 5.05965 7.1 4.99965 6.96V6.94L5.06965 6.9C5.21965 6.79 5.29965 6.59 5.25965 6.4V6.31L5.21965 6.02C5.19965 5.72 5.21965 5.4 5.29965 5.1C5.36965 4.85 5.46965 4.63 5.61965 4.44C5.93965 4.04 6.47965 3.83 7.23965 3.83H7.43965C8.09965 3.87 8.56965 4.07 8.86965 4.44C9.01965 4.62 9.11965 4.84 9.18965 5.1C9.28965 5.47 9.29965 5.87 9.24965 6.24L9.22965 6.4V6.48C9.20965 6.67 9.31965 6.85 9.49965 6.94V6.97C9.42965 7.11 9.20965 7.39 8.98965 7.58C8.87965 7.67 8.81965 7.81 8.81965 7.96C8.81965 8.13 8.80965 8.3 8.77965 8.45C8.75965 8.57 8.72965 8.69 8.69965 8.79L8.65965 8.91C8.55965 9.2 8.42965 9.4 8.33965 9.5C8.24965 9.59 8.19965 9.72 8.19965 9.85C8.19965 10.01 8.21965 10.16 8.26965 10.31L8.31965 10.44V10.42C8.58965 11.11 9.18965 11.6 9.98965 11.97C10.1397 12.04 10.2897 12.1 10.4197 12.15L10.6097 12.22C10.6597 12.24 10.7097 12.24 10.7597 12.24C10.9797 12.24 11.1697 12.1 11.2397 11.89C11.3197 11.63 11.1697 11.35 10.9097 11.26L10.7797 11.21L10.5197 11.11C10.4097 11.06 10.2997 11.01 10.1797 10.95C9.64965 10.66 9.29965 10.33 9.21965 10C9.38965 9.76 9.54965 9.44 9.65965 9.06L9.70965 8.88L9.75965 8.65C9.78965 8.5 9.79965 8.34 9.80965 8.18C10.2597 7.74 10.5597 7.27 10.4997 6.78C10.4797 6.6 10.3997 6.42 10.2697 6.27C10.3797 5.4 10.2597 4.52 9.70965 3.82C9.17965 3.15 8.34965 2.82 7.25965 2.82C6.16965 2.82 5.33965 3.15 4.80965 3.82H4.77965Z" fill="#596591" />
          </svg>}
        </div>
            <div className="buttons-container">
            <Button className="button inverted"
                onClick={this.deleteUserProfile}
              >
                <FormattedMessage id="popUp.deleteUser.button.confirm" />
              </Button>
              <Button className="button"
                onClick={this.props.closeDeleteProfilePopUp}
              >
                <FormattedMessage id="popUp.deleteUser.button.cancel" />
              </Button>
            </div>
        </div>
      </Modal>
    );
  }
}

const mapState = (state: IReducerState) => ({
  screenType: state.screenType,
});

const mapDispatch = {
  disconnectUser: () => ({
    type: ReducerAction.USER_LOGGED_OUT,
  }),
  displayToast: (toastMessage: JSX.Element, toastType = ToastType.SUCCESS) => ({
    type: ReducerAction.TOAST,
    payload: { toastMessage, toastType },
  }),
};

const connector = connect(mapState, mapDispatch);
export default withRouter(connector(DeleteProfilePopup));
